export default {
	methods: {
		resetToken() {
			if(!this.$refs.hasOwnProperty('ReCaptcha')) {
				return
			}

			this.$refs['ReCaptcha'][0].resetValid()
		},
		fillRecaptchaToken(token) {
			this.recaptchaToken = token
		},
	}
}
